/**
 * Reformly Free Gifts — Auto-add/remove hidden gift line items for ReformerX products.
 *
 * When any ReformerX product is in the cart, 3 gift variants are added as hidden
 * line items (property _free_gift = 'true'). They are excluded from cart UI via
 * Liquid {% continue %} and from cart counts via JS correction.
 */
(function () {
  'use strict';

  var FREE_GIFT_HANDLES = [
    // ReformerX
    'reformerx-black',
    'reformerx-pink',
    'reformerx-purple',
    'reformerx-black-1',  // product.reformerx-v3 template — native swatches, one handle for all three colours
    // Plans
    'pilates-board-plan-purple',
    'pilates-board-plan-black',
    'pilates-board-plan-pink',
    // Summer Sale
    'pilates-board-purple-summer-sale',
    'pilates-board-black-summer-sale',
    'pilates-board-pink-summer-sale',
    // Basic kits
    'pilates-basic-kit',
    'pilates-basic-kit-1',
    'pilates-basic-kit-2',
    // Essential / Foundations
    'pilates-foundations-kit-1',
    // Starter Sculpt
    'starter-sculpt-set',
    'starter-sculpt-set-1',
    'starter-sculpt-set-2',
    // Total Tone
    'total-tone-set',
    'total-tone-set-1',
    'total-tone-set-2',
    // Power Set
    'pilates-power-set',
    'pilates-power-set-1',
    'pilates-power-set-2',
    // Complete Studio
    'complete-studio-kit',
    'complete-studio-set',
    'complete-studio-set-1',
    // OT001 landing page
    'reformly-pilates-board-1',
    // OT002 landing page
    'reformly-pilates-board-2',
    // OT003 landing page
    'reformly-pilates-board-3',
    // OT004 landing page
    'reformly-pilates-board-4',
    // OT005 landing page
    'reformly-pilates-board-5',
    /* OT006 landing page. Takes the SHARED set (GIFT_VARIANT_IDS), unlike OT005
       which replaces it — OT006's own bundle items (Pilates Mat, Weight Bands,
       Grip Socks) are added by the page itself, without the _free_gift property,
       so this file never sees them and the two sets do not collide. */
    'reformly-pilates-board-6'
  ];

  var GIFT_VARIANT_IDS = [
    45947079491641,
    45947083849785,
    45947083096121
  ];

  // Bundle gifts — split by board group so each removes only its own membership + socks
  var OLD_SOCKS_VARIANT_ID = 45924805967929;
  var SUMMER_SOCKS_VARIANT_ID = 45970505039929;
  // Reformly Plus bundle also ships a nutrition plan + express shipping gift (30-day / discounted)
  var R30_NUTRITION_VARIANT_ID = 46239945293881;
  var R30_SHIPPING_VARIANT_ID = 46239947489337;

  var OLD_BOARD_HANDLES = [
    'pilates-board-plan-purple',
    'pilates-board-plan-black',
    'pilates-board-plan-pink'
  ];
  var OLD_MEMBERSHIP_VARIANT_ID = 45924536549433;

  var SUMMER_BOARD_HANDLES = [
    'pilates-board-purple-summer-sale',
    'pilates-board-black-summer-sale',
    'pilates-board-pink-summer-sale'
  ];
  var SUMMER_MEMBERSHIP_VARIANT_ID = 45924536549433;

  var JULY4_YEARLY_BOARD_HANDLES = [
    'pilates-board-purple-4th-july-sale',
    'pilates-board-black-4th-july-sale-yearly',
    'pilates-board-pink-4th-july-sale-yearly'
  ];
  var JULY4_MONTHLY_BOARD_HANDLES = [
    'pilates-board-purple-4th-july-sale-monthly',
    'pilates-board-black-4th-july-sale-monthly',
    'pilates-board-pink-4th-july-sale-monthly'
  ];
  var BONUS_BOARD_HANDLES = [
    'pilates-board-bonus'
  ];
  var R30_BOARD_HANDLES = [
    'reformly-board-30-day-plan',
    'reformly-board-30-day-plan-discounted',
    'reformly-board-30-day-plan-quiz-offer',  // onboarding option 2 (bundled with the 1-month membership)
    'reformly-pilates-board'                  // 005/006/007 — carries either membership
  ];
  // 90-day boards — bundled with the 90-day-toned-transformation-plan membership
  var R90_BOARD_HANDLES = [
    'reformly-board-90-day-plan',
    'reformly-board-90-day-plan-quiz-offer',  // onboarding option 1
    'reformly-pilates-board'                  // 005/006/007 — carries either membership
  ];

  // OT001 landing page — the board carries one of three Transformation Program
  // subscriptions, added as a second line item at add-to-cart.
  //
  // Paired at VARIANT level, not handle level. A handle-level check counts every
  // board variant together, so a cart holding a 28-Day board and a 90-Day board
  // keeps both programs alive when either board is removed — the orphaned
  // subscription survives and is still charged. Each program is tied to exactly
  // the three colour variants of its own plan.
  // The generic gift set ships the 60-Day digital product. On OT001 the gift
  // must match the plan the buyer chose, so the 60-Day gift variant is swapped
  // for the plan's own. 60-Day keeps the shared one.
  // On OT001 the program is SOLD as a subscription line item, so shipping the
  // 60-Day Program digital product as a free gift would duplicate what the buyer
  // just paid for. Dropped from the gift set whenever an OT001 board is present;
  // the other gifts (14-Day Kickstart, 100+ Workouts) still apply.
  var OT001_EXCLUDED_GIFT_ID = 45947083849785; // 60-Day Program (Digital Product)

  /* Two different gates, deliberately separate.

     OT006_PLAN_BOARDS — the six "With Plan" variants, either bundle. These earn
     the shared gift set, and drop the 60-Day digital product from it because the
     page sells that programme as a paid subscription line.

     OT006_BUNDLE_BOARDS — all six "Board Bundle" variants, BOTH plans. The Mat /
     Weight Bands / Grip Socks are what make it a bundle, so the toggle does not
     gate them; the page adds them itself and this list keeps the legacy socks
     sweep from deleting them and drives their removal with the board. */
  var OT006_PLAN_BOARDS = [
    46458154844217, 46458154909753, 46458154975289,  // Board / With Plan
    46458132987961, 46458133053497, 46458133119033   // Board Bundle / With Plan
  ];
  var OT006_BUNDLE_BOARDS = [
    46458132987961, 46458133053497, 46458133119033,  // Board Bundle / With Plan
    46458133020729, 46458133086265, 46458133151801   // Board Bundle / One-Time
  ];

  /* The two recurring programmes the offer sells alongside the board. Removed
     with it: an orphaned subscription here is not cosmetic, it bills forever.
     Safe to key on variant id alone — no other page sells these two. */
  var OT006_PROGRAM_VARIANTS = [
    46459915206713, // 60-Day Transformation Program  (Board,        plan 6871351353)
    46459983921209  // 90-Day Transformation Program  (Board Bundle, plan 6871384121)
  ];

  // OT002's boards. They sell the same 60-Day program as OT001's 60-Day plan, so
  // they share its pairing entry below and get the same treatment throughout:
  // the program is a paid subscription line, so the free 60-Day digital product
  // is dropped from the gift set rather than duplicating what was just bought.
  var OT002_BOARDS = [46392279924793, 46392279957561, 46392279990329];

  var OT001_PLANS = [
    {
      plan: '28-Day',
      program: 46390418833465,
      boards: [46390404775993, 46390404808761, 46390404841529] // Lavender, Black, Pink
    },
    {
      plan: '60-Day',
      program: 46390421684281,
      // OT002 sells the same 60-Day program against its own board, so its three
      // colour variants join this entry rather than getting one of their own —
      // two entries pointing at one program variant would fight over its
      // quantity when a cart holds both boards.
      boards: [46390405890105, 46390405955641, 46390406021177].concat(OT002_BOARDS)
    },
    {
      plan: '90-Day',
      program: 46390424698937,
      boards: [46390405922873, 46390405988409, 46390406053945]
    },
    /* OT003 (reformly-pilates-board-3). Its own INTRO program products, priced
       at the discounted first payment — a Seal product swap converts each to
       the full-price product before the 2nd payment, so the ids below are only
       ever what the storefront adds. The One Time Purchase variants
       (46394757742649 / 46394757840953 / 46394757939257) are absent on purpose:
       that plan sells the board alone, so there is no program to pair. */
    {
      plan: 'OT003 90-Day',
      program: 46394724679737,
      boards: [46394757808185, 46394757906489, 46394758004793] // Black, Lavender, Pink
    },
    {
      plan: 'OT003 60-Day',
      program: 46394724417593,
      boards: [46394757775417, 46394757873721, 46394757972025]
    },
    /* OT004 (reformly-pilates-board-4). One plan only — the 28-Day program, on
       its own subscription product (28-day-transformation-program-1, $27, sold
       with the first cycle free). Its One Time Purchase variants
       (46403501785145 / 46403501883449 / 46403501981753) are absent on purpose:
       that plan adds the board alone, so there is no subscription to pair and
       nothing to strip when it goes. */
    {
      plan: 'OT004 28-Day',
      program: 46403509616697,
      boards: [46403501752377, 46403501850681, 46403501948985] // Black, Lavender, Pink
    }
  ];

  var JULY4_YEARLY_MEMBERSHIP_VARIANT_ID = 46133255798841;
  var JULY4_MONTHLY_MEMBERSHIP_VARIANT_ID = 46181559992377;
  // 30-day-plan-bundle subscription — bundled with the R30 boards only
  var R30_MEMBERSHIP_VARIANT_ID = 46277813403705;
  // 90-day-toned-transformation-plan subscription — bundled with the R90 boards only
  var R90_MEMBERSHIP_VARIANT_ID = 46250514874425;
  /* OT005's board attaches ONE of these two Reformly+ subscriptions, chosen by
     the offer card's annual/monthly toggle. They are recurring charges, so they
     must not outlive their board — an orphan here bills the customer forever.
     Both are swept on the OT005 board leaving, and only that board: neither id
     appears in any other bundle, so no other page can be affected. */
  var OT005_MEMBERSHIP_VARIANT_IDS = [
    46434238398521, // Annual Reformly+ ($99.00/yr, plan 6783795257)
    46434230698041  // Flexible Reformly+ Plan ($19.99/4wk, plan 6747652153)
  ];

  var busy = false; // prevents re-entrant triggers

  /* ── helpers ─────────────────────────────────────────────── */

  function isHiddenItem(item) {
    return (
      (item.properties && item.properties._free_gift) ||
      GIFT_VARIANT_IDS.indexOf(item.variant_id) !== -1
    );
  }

  function getVisibleCount(cart) {
    var count = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (!isHiddenItem(cart.items[i])) {
        count += cart.items[i].quantity;
      }
    }
    return count;
  }

  /* OT003's One Time Purchase variants. The gift set is granted by HANDLE, and
     all nine OT003 board variants share one handle — so without this list the
     one-time buyer would collect the four gifts alongside the two subscription
     plans. Excluded from the trigger count instead of the handle list, so the
     90-Day and 60-Day variants on the same product still qualify. */
  var OT003_ONE_TIME_BOARDS = [
    46394757742649, 46394757840953, 46394757939257,
    // OT004's One Time Purchase colours. Same reasoning: all six OT004 variants
    // share the handle reformly-pilates-board-4, which is what grants the gift
    // set, so without these the one-time buyer would collect the gifts that pay
    // for the subscription plan they did not take.
    46403501785145, 46403501883449, 46403501981753,
    // OT005's One Time Purchase colours, for the same reason — all six board-5
    // variants share the handle reformly-pilates-board-5.
    46430866407481, 46430866473017, 46430866538553,
    /* OT006 contributes SIX: its twelve variants all share the handle
       reformly-pilates-board-6, and the shared gift set is earned by the PLAN,
       not by the bundle — both "Board" and "Board Bundle" qualify as long as
       "With Plan" is chosen. Only the six "One-Time" variants are excluded.

       The bundle items (Mat, Weight Bands, Grip Socks) are a separate thing and
       ARE Board-Bundle-only; they are added by the page itself and gated by
       OT006_BUNDLE_BOARDS below, not here. */
    46458154876985, 46458154942521, 46458155008057,  // Board / One-Time
    46458133020729, 46458133086265, 46458133151801   // Board Bundle / One-Time
  ];

  /* Boards whose buyer PAYS for a transformation programme, and therefore has
     the 60-Day digital product stripped from the shared gift set. The set swaps
     in the Personalized Nutrition Plan instead — a gift they aren't otherwise
     buying — so they still receive three gifts rather than two.

     One-time boards are absent throughout: that plan earns no gifts at all.

     Grouped per page because the two do NOT grant the same product. There are
     two Personalized Nutrition Plans in the store, and OT004 uses the newer
     one. Repointing a single shared id would have moved OT003's gift too. */
  var NUTRITION_GIFT_SETS = [
    {
      // OT003 (reformly-pilates-board-3)
      boards: [
        46394757808185, 46394757906489, 46394758004793, // 90-Day: Black, Lavender, Pink
        46394757775417, 46394757873721, 46394757972025  // 60-Day
      ],
      // personalized-nutrition-plan
      gifts: [46239945293881]
    },
    {
      // OT004 (reformly-pilates-board-4) — one plan, the 28-Day
      boards: [46403501752377, 46403501850681, 46403501948985], // Black, Lavender, Pink
      gifts: [
        46367471304761, // personalized-nutrition-plan-1 (product 8387818782777)
        45970505039929  // pilates-grip-socks-1 — the third tile on the card
      ]
    }
  ];

  // Flat list, for the callers that only need "is one of these boards present".
  var NUTRITION_GIFT_BOARDS = NUTRITION_GIFT_SETS.reduce(function (all, set) {
    return all.concat(set.boards);
  }, []);

  // OT004's own boards, kept separate from the flat list above because the
  // socks removal rule has to spare THIS page without also sparing OT003's.
  var OT004_GIFT_BOARDS = NUTRITION_GIFT_SETS[1].boards;

  function hasOt004GiftBoard(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (OT004_GIFT_BOARDS.indexOf(cart.items[i].variant_id) !== -1) return true;
    }
    return false;
  }

  // The swap gifts THIS cart earns, or an empty list.
  function swapGiftsFor(cart) {
    for (var s = 0; s < NUTRITION_GIFT_SETS.length; s++) {
      for (var i = 0; i < cart.items.length; i++) {
        if (NUTRITION_GIFT_SETS[s].boards.indexOf(cart.items[i].variant_id) !== -1) {
          return NUTRITION_GIFT_SETS[s].gifts;
        }
      }
    }
    return [];
  }

  function hasNutritionGiftBoard(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (NUTRITION_GIFT_BOARDS.indexOf(cart.items[i].variant_id) !== -1) return true;
    }
    return false;
  }

  function getReformerXQty(cart) {
    var qty = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (OT003_ONE_TIME_BOARDS.indexOf(item.variant_id) !== -1) continue;
      if (FREE_GIFT_HANDLES.indexOf(item.handle) !== -1) {
        qty += item.quantity;
      }
    }
    return qty;
  }

  /* OT005 does not take the shared gift set at all — it REPLACES it with its own
     six, which are what the offer block's "Included" row advertises. Four are
     OT005-only products; nutrition and socks are the existing shared ones.

     Keyed to the 28-Day board variants only. The One Time Purchase colours are
     in OT003_ONE_TIME_BOARDS above, so that plan earns nothing. */
  var OT005_BOARDS = [46430866374713, 46430866440249, 46430866505785];

  var OT005_GIFT_IDS = [
    46433853734969, // 30-day-plan-digital-product   $99
    46367471304761, // personalized-nutrition-plan-1 $20  (shared)
    46433855209529, // unlimited-classes             $30
    46433855963193, // progress-tracking             $10
    45970505039929  // pilates-grip-socks-1          $19.99 (shared)
  ];
  /* Published so OT005's ATC can post the gifts in the SAME /cart/add.js call as
     the board, instead of waiting for this file's next sync to add them in a
     second request. That gap is what leaves a cart briefly holding a board with
     no gifts — harmless while OT005 opens the drawer, fatal if it ever redirects
     straight to checkout (the app-membership02 bug). This list stays the one
     source of truth; the sync below still reconciles, and finds nothing missing. */
  window.reformlyOt005GiftIds = OT005_GIFT_IDS;


  function hasOt005Board(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (OT005_BOARDS.indexOf(cart.items[i].variant_id) !== -1) return true;
    }
    return false;
  }

  // GIFT_VARIANT_IDS with the OT001 substitution applied. Returns the shared
  // list untouched when no OT001 board is present, so every other page keeps its
  // existing behaviour.
  function effectiveGiftIds(cart) {
    // Checked first and returned whole: OT005 substitutes the entire set, so it
    // must not fall through to the OT001 filtering below.
    if (hasOt005Board(cart)) return OT005_GIFT_IDS;

    /* OT006 sells its programme as a PAID subscription line — the 60-Day or
       90-Day Transformation Program the offer block adds alongside the board —
       so shipping the free 60-Day Program digital product on top would hand the
       buyer a second copy of what they just paid for. Same reasoning as OT001
       and OT002 below; the other two gifts still apply. */
    var hasOt006Board = false;
    for (var q = 0; q < cart.items.length; q++) {
      if (OT006_PLAN_BOARDS.indexOf(cart.items[q].variant_id) !== -1) {
        hasOt006Board = true;
        break;
      }
    }

    var hasOt001Board = false;
    for (var p = 0; p < OT001_PLANS.length && !hasOt001Board; p++) {
      for (var i = 0; i < cart.items.length; i++) {
        var vid = cart.items[i].variant_id;
        if (OT001_PLANS[p].boards.indexOf(vid) !== -1) {
          hasOt001Board = true;
          break;
        }
      }
    }

    /* OT006 drops the 60-Day digital product and stops there — it takes no
       swap-in replacement, unlike OT003/OT004 below, so its buyers get the two
       remaining shared gifts plus the three bundle items the page adds itself. */
    if (hasOt006Board && !hasOt001Board) {
      return GIFT_VARIANT_IDS.filter(function (id) {
        return id !== OT001_EXCLUDED_GIFT_ID;
      });
    }

    if (!hasOt001Board) return GIFT_VARIANT_IDS;

    var ids = GIFT_VARIANT_IDS.filter(function (id) {
      return id !== OT001_EXCLUDED_GIFT_ID;
    });

    // OT003 and OT004 replace the dropped 60-Day digital product rather than
    // just losing it, so their buyers still receive three gifts. OT001 and
    // OT002 carts get the list unchanged.
    swapGiftsFor(cart).forEach(function (gid) {
      if (ids.indexOf(gid) === -1) ids = ids.concat([gid]);
    });

    return ids;
  }

  // Gift line items that no longer belong. Covers the OT001 case: adding that
  // board must clear the 60-Day Program gift if an earlier add already put it in
  // the cart.
  function getStaleGiftItems(cart) {
    var wanted = effectiveGiftIds(cart);
    var stale = [];
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!item.properties || !item.properties._free_gift) continue;
      if (wanted.indexOf(item.variant_id) === -1) stale.push(item);
    }
    return stale;
  }

  function getGiftItems(cart) {
    // Against the EFFECTIVE list, not the static one — otherwise a swapped
    // OT001 gift is not recognised as a gift, so it never gets its quantity
    // synced and never gets removed with the rest.
    var wanted = effectiveGiftIds(cart);
    var gifts = [];
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (
        item.properties &&
        item.properties._free_gift &&
        wanted.indexOf(item.variant_id) !== -1
      ) {
        gifts.push(item);
      }
    }
    return gifts;
  }

  function getMissingGiftIds(cart) {
    var wanted = effectiveGiftIds(cart);
    var missing = [];
    for (var g = 0; g < wanted.length; g++) {
      var found = false;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (
          item.variant_id === wanted[g] &&
          item.properties &&
          item.properties._free_gift
        ) {
          found = true;
          break;
        }
      }
      if (!found) missing.push(wanted[g]);
    }
    return missing;
  }

  /* ── DOM count correction ───────────────────────────────── */

  function updateDomCounts(cart) {
    var count = getVisibleCount(cart);

    // Header badge(s): .cart-count-bubble > span[aria-hidden]
    var badges = document.querySelectorAll('.cart-count-bubble');
    for (var i = 0; i < badges.length; i++) {
      var span = badges[i].querySelector('span[aria-hidden]');
      if (span) span.textContent = count;
      badges[i].style.display = count > 0 ? '' : 'none';
    }

    // Drawer header: #ajax-cart-quantity
    var drawerQty = document.getElementById('ajax-cart-quantity');
    if (drawerQty) drawerQty.textContent = count;
  }

  /* ── cart mutations (via liquid-ajax-cart API) ───────────── */

  function addGifts(missing, qty, callback) {
    var items = [];
    for (var i = 0; i < missing.length; i++) {
      items.push({
        id: missing[i],
        quantity: qty,
        properties: { _free_gift: 'true' }
      });
    }

    if (window.liquidAjaxCart && window.liquidAjaxCart.add) {
      window.liquidAjaxCart.add(
        { items: items },
        {
          lastCallback: function () {
            if (callback) callback();
          }
        }
      );
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function () {
          /* Fallback branch only — the liquidAjaxCart path above is observed by
             theme.liquid, this one emits nothing. See layout/theme.liquid. */
          if (window.rfStampCart) rfStampCart();
          if (callback) callback();
        })
        .catch(function () { if (callback) callback(); });
    }
  }

  /* Line-precise quantity update.

     updateGiftQty below keys `updates` by VARIANT ID, which cannot address one
     line when two share a variant — and OT006's gift lines do exactly that: the
     colourless Grip Socks appears once per bundle, same variant, distinguished
     only by its _ot006_gift parent. Zeroing by id removed BOTH socks lines when
     one board was taken out.

     The positional array form of /cart/update.js addresses lines by index, so
     each one can be changed on its own. Kept separate rather than folded into
     updateGiftQty: every other offer pairs one line per variant and works fine
     on the id form, and this is not the file to refactor speculatively.

     `lines` are items taken from THIS cart object, so identity comparison is
     what pairs them back to their index. */
  /* Same positional-array update, but one target per line — two gift lines can
     need different quantities when their parent boards do. */
  function updateLinesQtyEach(cart, lines, targets, callback) {
    var quantities = [];
    for (var i = 0; i < cart.items.length; i++) {
      var target = cart.items[i].quantity;
      for (var l = 0; l < lines.length; l++) {
        if (lines[l] === cart.items[i]) { target = targets[l]; break; }
      }
      quantities.push(target);
    }

    if (window.liquidAjaxCart && window.liquidAjaxCart.update) {
      window.liquidAjaxCart.update(
        { updates: quantities },
        { lastCallback: function () { if (callback) callback(); } }
      );
    } else {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: quantities })
      })
        .then(function () { if (callback) callback(); })
        .catch(function () { if (callback) callback(); });
    }
  }

  function updateLinesQty(cart, lines, targetQty, callback) {
    var quantities = [];
    for (var i = 0; i < cart.items.length; i++) {
      var target = cart.items[i].quantity;
      for (var l = 0; l < lines.length; l++) {
        if (lines[l] === cart.items[i]) { target = targetQty; break; }
      }
      quantities.push(target);
    }

    if (window.liquidAjaxCart && window.liquidAjaxCart.update) {
      window.liquidAjaxCart.update(
        { updates: quantities },
        { lastCallback: function () { if (callback) callback(); } }
      );
    } else {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: quantities })
      })
        .then(function () { if (callback) callback(); })
        .catch(function () { if (callback) callback(); });
    }
  }

  function updateGiftQty(giftItems, targetQty, callback) {
    var updates = {};
    for (var i = 0; i < giftItems.length; i++) {
      updates[String(giftItems[i].variant_id)] = targetQty;
    }

    if (window.liquidAjaxCart && window.liquidAjaxCart.update) {
      window.liquidAjaxCart.update(
        { updates: updates },
        {
          lastCallback: function () {
            if (callback) callback();
          }
        }
      );
    } else {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function () { if (callback) callback(); })
        .catch(function () { if (callback) callback(); });
    }
  }

  /* ── main handler (runs after every cart mutation) ──────── */

  // Keep each program's quantity equal to its own plan's board quantity.
  //
  // Presence alone is not enough: adding the same board twice merges into one
  // line at qty 2 and the program follows, so dropping the board to 1 would
  // leave 2 subscriptions billing. Zero board qty means zero program, which also
  // covers removal.
  function syncOt001ProgramQty(cart, callback) {
    var updates = {};
    var changed = false;

    for (var p = 0; p < OT001_PLANS.length; p++) {
      var plan = OT001_PLANS[p];

      var boardQty = 0;
      var programLine = null;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (plan.boards.indexOf(item.variant_id) !== -1) boardQty += item.quantity;
        if (item.variant_id === plan.program) programLine = item;
      }

      if (!programLine) continue;
      if (programLine.quantity === boardQty) continue;

      updates[String(plan.program)] = boardQty;
      changed = true;
    }

    if (!changed) return false;

    if (window.liquidAjaxCart && window.liquidAjaxCart.update) {
      window.liquidAjaxCart.update({ updates: updates }, {
        lastCallback: function () { if (callback) callback(); }
      });
    } else {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function () { if (callback) callback(); })
        .catch(function () { if (callback) callback(); });
    }
    return true;
  }

  // Keep OT005's membership quantity equal to its board quantity.
  //
  // Same failure syncOt001ProgramQty guards against, but the pairing is looser:
  // the two Reformly+ subscriptions are not tied to a board VARIANT the way an
  // OT001 programme is to its plan, because the cycle is chosen in the offer
  // card, not as a product option. So the target is on the TOTAL across both
  // ids, not per id.
  //
  // The case that reported this: two boards added, one Annual and one Flexible,
  // then the board line dropped 2 -> 1. Board qty 1, membership total 2, and
  // both subscriptions kept billing.
  //
  // Trims from the LAST cart line backwards, so the earliest-added membership
  // survives. Deterministic, and matches "first choice wins".
  //
  // Only trims down. A board qty INCREASE is matched only in the unambiguous
  // single-membership case: with both cycles present there is no way to know
  // which the extra board should carry, and silently adding a recurring charge
  // is the worse error. The buyer adds the second from the page.
  function syncOt005MembershipQty(cart, callback) {
    var boardQty = 0;
    var lines = [];
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (OT005_BOARDS.indexOf(item.variant_id) !== -1) boardQty += item.quantity;
      if (OT005_MEMBERSHIP_VARIANT_IDS.indexOf(item.variant_id) !== -1) {
        lines.push(item);
        total += item.quantity;
      }
    }

    // Zero board qty is the bundle sweep's job — it removes both ids outright.
    // Bailing here stops the two rules fighting over the same lines each sync.
    if (!lines.length || boardQty === 0 || total === boardQty) return false;

    var updates = {};
    if (total < boardQty) {
      if (lines.length !== 1) return false;
      updates[String(lines[0].variant_id)] = boardQty;
    } else {
      var excess = total - boardQty;
      for (var j = lines.length - 1; j >= 0 && excess > 0; j--) {
        var cut = Math.min(excess, lines[j].quantity);
        updates[String(lines[j].variant_id)] = lines[j].quantity - cut;
        excess -= cut;
      }
    }

    if (window.liquidAjaxCart && window.liquidAjaxCart.update) {
      window.liquidAjaxCart.update({ updates: updates }, {
        lastCallback: function () { if (callback) callback(); }
      });
    } else {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function () { if (callback) callback(); })
        .catch(function () { if (callback) callback(); });
    }
    return true;
  }

  function handleCartChange() {
    if (busy) return;
    // Skip all gift logic on membership page to prevent cart drawer opening
    if (document.querySelector('.rmh__page')) return;

    var cart =
      window.liquidAjaxCart && window.liquidAjaxCart.cart
        ? window.liquidAjaxCart.cart
        : null;

    if (!cart) return;

    // Always correct visible counts
    updateDomCounts(cart);

    // Program quantity must track its board's. Returns early while the update
    // is in flight; the resulting cart change re-enters here.
    if (syncOt001ProgramQty(cart, function () { busy = false; handleCartChange(); })) {
      busy = true;
      return;
    }

    if (syncOt005MembershipQty(cart, function () { busy = false; handleCartChange(); })) {
      busy = true;
      return;
    }

    var rxQty = getReformerXQty(cart);

    // Plan switched: bin the previous plan's digital product first, so the
    // add below cannot briefly leave two program gifts in the cart.
    var stale = getStaleGiftItems(cart);
    if (stale.length > 0) {
      busy = true;
      updateGiftQty(stale, 0, function () {
        busy = false;
        handleCartChange();
      });
      return;
    }

    var giftItems = getGiftItems(cart);
    var missing = getMissingGiftIds(cart);

    if (rxQty > 0 && missing.length > 0) {
      // ReformerX present but some gifts missing → add exactly 1 of each
      busy = true;
      addGifts(missing, 1, function () {
        busy = false;
        handleCartChange(); // re-check in case add was partial
      });
    } else if (rxQty > 0 && giftItems.length > 0) {
      // All gifts present — ensure quantity stays at 1
      var needsSync = false;
      for (var i = 0; i < giftItems.length; i++) {
        if (giftItems[i].quantity !== 1) {
          needsSync = true;
          break;
        }
      }
      if (needsSync) {
        busy = true;
        updateGiftQty(giftItems, 1, function () {
          busy = false;
          handleCartChange(); // re-check in case update was partial
        });
      }
    } else if (rxQty === 0 && giftItems.length > 0) {
      // No qualifying products → remove hidden gifts
      busy = true;
      updateGiftQty(giftItems, 0, function () {
        busy = false;
        handleCartChange();
      });
    }

    // Separately: remove bundle gifts per board group
    if (!busy) {
      var oldBoardQty = 0;
      var summerBoardQty = 0;
      var july4YearlyBoardQty = 0;
      var july4MonthlyBoardQty = 0;
      var bonusBoardQty = 0;
      var r30BoardQty = 0;
      var r90BoardQty = 0;
      var nutritionGiftBoardQty = 0;
      var ot004BoardQty = 0;
      var ot005BoardQty = 0;
      var ot006BoardQty = 0;
      var ot006PlanQty = 0;
      var ot001PlanQty = {};
      for (var p = 0; p < cart.items.length; p++) {
        if (OLD_BOARD_HANDLES.indexOf(cart.items[p].handle) !== -1) {
          oldBoardQty += cart.items[p].quantity;
        }
        if (SUMMER_BOARD_HANDLES.indexOf(cart.items[p].handle) !== -1) {
          summerBoardQty += cart.items[p].quantity;
        }
        if (JULY4_YEARLY_BOARD_HANDLES.indexOf(cart.items[p].handle) !== -1) {
          july4YearlyBoardQty += cart.items[p].quantity;
        }
        if (JULY4_MONTHLY_BOARD_HANDLES.indexOf(cart.items[p].handle) !== -1) {
          july4MonthlyBoardQty += cart.items[p].quantity;
        }
        if (BONUS_BOARD_HANDLES.indexOf(cart.items[p].handle) !== -1) {
          bonusBoardQty += cart.items[p].quantity;
        }
        if (R30_BOARD_HANDLES.indexOf(cart.items[p].handle) !== -1) {
          r30BoardQty += cart.items[p].quantity;
        }
        if (NUTRITION_GIFT_BOARDS.indexOf(cart.items[p].variant_id) !== -1) {
          nutritionGiftBoardQty += cart.items[p].quantity;
        }
        if (OT004_GIFT_BOARDS.indexOf(cart.items[p].variant_id) !== -1) {
          ot004BoardQty += cart.items[p].quantity;
        }
        if (OT005_BOARDS.indexOf(cart.items[p].variant_id) !== -1) {
          ot005BoardQty += cart.items[p].quantity;
        }
        if (OT006_BUNDLE_BOARDS.indexOf(cart.items[p].variant_id) !== -1) {
          ot006BoardQty += cart.items[p].quantity;
        }
        if (OT006_PLAN_BOARDS.indexOf(cart.items[p].variant_id) !== -1) {
          ot006PlanQty += cart.items[p].quantity;
        }
        if (R90_BOARD_HANDLES.indexOf(cart.items[p].handle) !== -1) {
          r90BoardQty += cart.items[p].quantity;
        }
        for (var op = 0; op < OT001_PLANS.length; op++) {
          if (OT001_PLANS[op].boards.indexOf(cart.items[p].variant_id) !== -1) {
            ot001PlanQty[OT001_PLANS[op].program] =
              (ot001PlanQty[OT001_PLANS[op].program] || 0) + cart.items[p].quantity;
          }
        }
      }

      /* A page that sells a membership standalone must not have it swept as an
         orphan. `.rmh__page` covers the four reformly-membership-hero* pages;
         [data-membership-standalone] is the opt-in marker for any other, and
         is what app-membership-002/003 use — they render reformly-am002-hero,
         which has no .rmh__page, so the 90-Day membership was being deleted
         the moment it was added. */
      var isMembershipPage = !!document.querySelector('.rmh__page, [data-membership-standalone]');
      var bundleRemovals = [];
      for (var b = 0; b < cart.items.length; b++) {
        var vid = cart.items[b].variant_id;
        if (!isMembershipPage && oldBoardQty === 0 && summerBoardQty === 0 && july4MonthlyBoardQty === 0 && vid === OLD_MEMBERSHIP_VARIANT_ID) {
          bundleRemovals.push(cart.items[b]);
        }
        if (!isMembershipPage && july4YearlyBoardQty === 0 && r30BoardQty === 0 && vid === JULY4_YEARLY_MEMBERSHIP_VARIANT_ID) {
          bundleRemovals.push(cart.items[b]);
        }
        if (!isMembershipPage && r30BoardQty === 0 && vid === R30_MEMBERSHIP_VARIANT_ID) {
          bundleRemovals.push(cart.items[b]);
        }
        if (!isMembershipPage && r90BoardQty === 0 && vid === R90_MEMBERSHIP_VARIANT_ID) {
          bundleRemovals.push(cart.items[b]);
        }
        if (!isMembershipPage && oldBoardQty === 0 && summerBoardQty === 0 && july4MonthlyBoardQty === 0 && r30BoardQty === 0 && vid === JULY4_MONTHLY_MEMBERSHIP_VARIANT_ID) {
          bundleRemovals.push(cart.items[b]);
        }
        if (!isMembershipPage && ot005BoardQty === 0 && OT005_MEMBERSHIP_VARIANT_IDS.indexOf(vid) !== -1) {
          bundleRemovals.push(cart.items[b]);
        }
        // ot004BoardQty guard, exactly like the nutrition one below: OT004 hands
        // the socks out as one of its three card gifts, so without this the
        // bundle sweep would delete them the moment they were added and the two
        // rules would fight on every sync. NOT nutritionGiftBoardQty — that also
        // counts OT003's boards, and OT003 does not grant socks.
        if (summerBoardQty === 0 && july4YearlyBoardQty === 0 && july4MonthlyBoardQty === 0 && bonusBoardQty === 0 && r30BoardQty === 0 && r90BoardQty === 0 && ot004BoardQty === 0 && ot005BoardQty === 0 && vid === SUMMER_SOCKS_VARIANT_ID) {
          bundleRemovals.push(cart.items[b]);
        }
        // nutritionGiftBoardQty guard: OT003 hands out the nutrition plan as one of
        // its gifts, so without this the bundle sweep would delete it the moment
        // it was added and the two rules would fight each other on every sync.
        if (july4YearlyBoardQty === 0 && r30BoardQty === 0 && r90BoardQty === 0 && nutritionGiftBoardQty === 0 && (vid === R30_NUTRITION_VARIANT_ID || vid === R30_SHIPPING_VARIANT_ID)) {
          bundleRemovals.push(cart.items[b]);
        }
        /* ot006BoardQty guard. OT006 now ships its OWN duplicate socks
           (46462330241081), so it no longer collides with this legacy variant —
           but the guard stays: it costs nothing, and it is what stopped the
           legacy sweep deleting the socks the moment they were added while the
           two shared one variant. Remove only if OT006 is retired. */
        if (oldBoardQty === 0 && july4YearlyBoardQty === 0 && july4MonthlyBoardQty === 0 && ot006BoardQty === 0 && vid === OLD_SOCKS_VARIANT_ID) {
          bundleRemovals.push(cart.items[b]);
        }
        /* OT006's bundle items go with the board that earned them, PER COLOUR.
           Matched on the _ot006_gift property rather than on variant id alone:
           Pilates Mat and Weight Bands are ordinary products someone can buy on
           their own, and deleting by id would remove one the customer paid for.

           The line names its parent board variant, so the rule is simply "is
           that board still in the cart" — no pairing table to maintain here, and
           nothing to keep in step with the snippet that does the adding. Remove
           the Black bundle and Black's three lines go; Pink's stay. */
        if (cart.items[b].properties && cart.items[b].properties._ot006_gift) {
          var parentId = String(cart.items[b].properties._ot006_gift);
          var parentPresent = false;
          for (var pb = 0; pb < cart.items.length; pb++) {
            if (String(cart.items[pb].variant_id) === parentId) { parentPresent = true; break; }
          }
          if (!parentPresent) bundleRemovals.push(cart.items[b]);
        }
        /* The programme goes with the board that bought it, matched the same way
           as the gifts: the line names its parent in _ot006_plan.

           A count-based rule ("no With Plan board left") was not enough — with
           two bundles in the cart, removing one left the other's count above
           zero and BOTH subscriptions survived, billing twice. The property also
           stops the two lines merging into one at quantity 2, since Shopify keys
           a line on variant plus properties. */
        if (cart.items[b].properties && cart.items[b].properties._ot006_plan) {
          var planParent = String(cart.items[b].properties._ot006_plan);
          var planParentPresent = false;
          for (var pp = 0; pp < cart.items.length; pp++) {
            if (String(cart.items[pp].variant_id) === planParent) { planParentPresent = true; break; }
          }
          if (!planParentPresent) bundleRemovals.push(cart.items[b]);
        }

        /* Belt and braces for carts created BEFORE the property existed: those
           programme lines carry no parent, so fall back to the count rule. */
        if (ot006PlanQty === 0 && OT006_PROGRAM_VARIANTS.indexOf(vid) !== -1 &&
            !(cart.items[b].properties && cart.items[b].properties._ot006_plan)) {
          bundleRemovals.push(cart.items[b]);
        }
        // OT001: a program goes the moment ITS OWN plan's board leaves, even if
        // a board on a different plan is still in the cart. No membership-page
        // guard — there is no page that sells these variants standalone.
        for (var oq = 0; oq < OT001_PLANS.length; oq++) {
          if (vid === OT001_PLANS[oq].program && !ot001PlanQty[OT001_PLANS[oq].program]) {
            bundleRemovals.push(cart.items[b]);
            break;
          }
        }
      }

      if (bundleRemovals.length > 0) {
        busy = true;
        // Line-precise: two OT006 socks lines share a variant, so the id-keyed
        // update would zero both when only one board was removed.
        updateLinesQty(cart, bundleRemovals, 0, function () {
          busy = false;
          handleCartChange();
        });
        return;
      }

      /* Keep each OT006 gift and programme line at the SAME quantity as the
         board that earned it.

         Was a hard clamp to 1, which was right only while lines could merge
         across colours — two bundles both adding the colourless Grip Socks
         collapsed into one line at quantity 2. Parent ids fixed that, and the
         clamp then became wrong in the other direction: adding the same bundle
         twice legitimately gives quantity 2, and the clamp kept deleting one of
         each.

         Syncing to the parent's quantity covers both. A line whose parent is
         gone is not touched here — the sweep above removes it outright. */
      var boardQtyByVariant = {};
      for (var bq = 0; bq < cart.items.length; bq++) {
        var bqId = String(cart.items[bq].variant_id);
        boardQtyByVariant[bqId] = (boardQtyByVariant[bqId] || 0) + cart.items[bq].quantity;
      }

      var qtyMismatch = [];
      var qtyTargets = [];
      for (var gq = 0; gq < cart.items.length; gq++) {
        var gItem = cart.items[gq];
        if (!gItem.properties) continue;
        var parent = gItem.properties._ot006_gift || gItem.properties._ot006_plan;
        if (!parent) continue;
        var want = boardQtyByVariant[String(parent)];
        if (want && gItem.quantity !== want) {
          qtyMismatch.push(gItem);
          qtyTargets.push(want);
        }
      }
      if (qtyMismatch.length > 0) {
        busy = true;
        updateLinesQtyEach(cart, qtyMismatch, qtyTargets, function () {
          busy = false;
          handleCartChange();
        });
      }
    }
  }

  /* ── event binding ──────────────────────────────────────── */

  function init() {
    document.addEventListener('liquid-ajax-cart:request-end', function (event) {
      handleCartChange();

      // Track summer sale board add-to-cart in PostHog
      if (
        window.posthog &&
        event.detail &&
        event.detail.requestState &&
        event.detail.requestState.requestType === 'add'
      ) {
        var cart = window.liquidAjaxCart && window.liquidAjaxCart.cart;
        if (cart) {
          for (var t = 0; t < cart.items.length; t++) {
            if (SUMMER_BOARD_HANDLES.indexOf(cart.items[t].handle) !== -1) {
              window.posthog.capture('summer_sale_add_to_cart', {
                product_title: cart.items[t].title,
                variant_title: cart.items[t].variant_title,
                variant_id: cart.items[t].variant_id,
                handle: cart.items[t].handle,
                price: cart.items[t].price
              });
              break; // one event per add action
            }
          }
        }
      }
    });

    // Handle bfcache restore (browser back from checkout)
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        // Page restored from bfcache — cart state may be stale, re-fetch and correct
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateDomCounts(cart);
          })
          .catch(function () { });
      }
    });

    // Run once on init to catch page-load state
    handleCartChange();

    // Page view tracking for summer sale products
    if (window.posthog) {
      var path = window.location.pathname;
      for (var s = 0; s < SUMMER_BOARD_HANDLES.length; s++) {
        if (path.indexOf(SUMMER_BOARD_HANDLES[s]) !== -1) {
          window.posthog.capture('summer_sale_page_view', {
            handle: SUMMER_BOARD_HANDLES[s],
            url: window.location.href,
            referrer: document.referrer
          });
          break;
        }
      }
    }
  }

  if (window.liquidAjaxCart && window.liquidAjaxCart.init) {
    init();
  } else {
    document.addEventListener('liquid-ajax-cart:init', function () {
      init();
    });
  }
})();
